import React from "react";
import "./style.css";

const MatchHeader = ({ match }) => {
  if (!match) return null;

  return (
    <div className="match-header">
      <div className="team-info">
        <img
          src={match.first_team_logo || "/default-logo.png"}
          alt={match.first_team_name}
          className="team-logo"
        />
        <div className="team-name">{match.first_team_name}</div>
      </div>

      <div className="match-center">
        <div className="score-box">
          <span className="score">{match.first_team_score}</span>
          <span className="vs">-</span>
          <span className="score">{match.second_team_score}</span>
        </div>
        <div className="match-date">
          <i className="far fa-calendar-alt"></i> {match.date || "Maç Tarihi"}
        </div>
      </div>

      <div className="team-info">
        <img
          src={match.second_team_logo || "/default-logo.png"}
          alt={match.second_team_name}
          className="team-logo"
        />
        <div className="team-name">{match.second_team_name}</div>
      </div>
    </div>
  );
};

export default MatchHeader;
